import React from "react";
import { useLocation } from "react-router-dom";
import { getAppParams } from "../utils/appParams";

function useQuery() {
  const { search, hash } = useLocation();

  // Hash-aware: params may arrive in the query string OR the URL
  // fragment (see utils/appParams.js for why).
  return React.useMemo(() => getAppParams(), [search, hash]);
}

export default useQuery;
